import React, {FC, memo} from 'react'
import {Controller, useFormContext, useWatch} from 'react-hook-form'

import TextField from '@pixel/core/TextField'
import {LocalizedText} from "../../contexts/Localization/LocalizationTypes";
import {styled} from "@pixel/core/styles";
import {useMultipleLocalizedText} from "../../contexts/Localization/localizationHooks";
import CircularProgress from "@pixel/core/CircularProgress";
import LocalizedTypography from "../../components/LocalizedTypography";
import MenuItem from "@pixel/core/MenuItem";
import useAutomationFormActionValuesDataQuery, {
    DEFAULT_AUTOMATION_FORM_ACTION_VALUES_DATA
} from "../hooks/useAutomationFormActionValuesDataQuery";

interface ActionValueProps {
    actionValueIndex: number
}

const ActionValueSection = styled('div')(({ theme }) => ({
    marginTop: theme.spacing(2),
}))

const ActionLoadingContainer = styled('div')(({ theme }) => ({
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(1),
}))

const ActionValue: FC<ActionValueProps> = ({
    actionValueIndex,
    children,
}) => {

    const {
        AUTOMATION_INPUT_NO_OPTIONS,
    } = useMultipleLocalizedText()

    const { control } = useFormContext()

    const actionType = useWatch({ name: `companyActions.${actionValueIndex}.actionFields.0.actionField`, control })

    const {
        data,
        status,
    } = useAutomationFormActionValuesDataQuery(actionType, {
        onSuccess: () => {},
    })

    const { AVAILABLE_ACTION_FIELD_VALUES } = data || DEFAULT_AUTOMATION_FORM_ACTION_VALUES_DATA

    if (status === 'loading') {
        return (
            <ActionLoadingContainer>
                <CircularProgress size="32px" />
            </ActionLoadingContainer>
        )
    }

    if (status === 'error'){
        return (
            <ActionLoadingContainer>
                <LocalizedTypography color="error" text={LocalizedText.AUTOMATION_FORM_ERROR_ACTION} />
            </ActionLoadingContainer>
        )
    }

    if (actionType === undefined) return null

    return (
        <>
            <ActionValueSection>
                <Controller
                    control={control}
                    name={`companyActions.${actionValueIndex}.actionFields.0.companyActionValues.0.value`}
                    render={({ field, fieldState, }) => (
                        <TextField
                            id={`automation-form-action-value-field-${actionValueIndex}`}
                            required
                            select
                            value={field.value}
                            onBlur={field.onBlur}
                            onChange={field.onChange}
                            error={fieldState.invalid}
                            errorText={fieldState?.error?.message || ''}
                            fullWidth
                            disabled={AVAILABLE_ACTION_FIELD_VALUES.length === 0}
                        >
                            {
                                AVAILABLE_ACTION_FIELD_VALUES.length === 0 ?
                                    (
                                        <MenuItem value="none" disabled>{AUTOMATION_INPUT_NO_OPTIONS}</MenuItem>
                                    ) :
                                    (
                                        AVAILABLE_ACTION_FIELD_VALUES.map((el: any) => {
                                            return (
                                                <MenuItem key={el.referenceKey} value={el.referenceKey}>{el.value}</MenuItem>
                                            )})
                                    )
                            }
                        </TextField>
                        )}
                />
            </ActionValueSection>
            <>{children}</>
        </>
    )
}

export default memo(ActionValue)
